import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import { NextSeo } from "next-seo";

import Header from "../../Header";
import Footer from "../../Footer";
import SideMenu from "../../SideMenu";
import { NavigationBar } from "../../../src/components/atoms";
import { Constants, Values } from "../../../src/config";
import { useRouter } from "next/router";

const GuideYear = (props) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { listData } = props;
  const [sideMenuShow, setSideMenuShow] = useState(false);
  const [sideMenuHeaderShow, setSideMenuHeaderShow] = useState(false);
  const [isMobileVersion, setIsMobileVersion] = useState(false);

  useEffect(() => {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);

  return (
    <div>
      <NextSeo
        noindex={false}
        nofollow={false}
        title={`Year Guides - ${process.env.NEXT_PUBLIC_APP_NAME}`}
        description={`Discover ${
          process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
            ? "clubs"
            : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
            ? "rooftops"
            : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
            ? "cocktail bars"
            : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
            ? "spas"
            : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
            ? "beach clubs"
            : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
            ? "festivals"
            : "clubs"
        } around the World with our guides.`}
        canonical={`https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/guides`}
        openGraph={{
          type: "website",
          locale: "en_EN",
          url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/guides`,
          title: `Year Guides - ${process.env.NEXT_PUBLIC_APP_NAME}`,
          description: `Discover ${
            process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
              ? "clubs"
              : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
              ? "rooftops"
              : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
              ? "cocktail bars"
              : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
              ? "spas"
              : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
              ? "beach clubs"
              : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
              ? "festivals"
              : "clubs"
          } around the World with our guides.`,
          images: [
            {
              url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}${process.env.NEXT_PUBLIC_BANNER_IMAGE}`,
              width: 1200,
              height: 630,
              alt: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
              type: "image/png",
            },
          ],
          siteName: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
        }}
      />
      <Header setSideMenuShow={setSideMenuShow} />

      <SideMenu
        sideMenuShow={sideMenuShow}
        setSideMenuShow={setSideMenuShow}
        sideMenuHeaderShow={sideMenuHeaderShow}
        setSideMenuHeaderShow={setSideMenuHeaderShow}
      />

      <div className="bg-black">
        <div
          className={`mx-auto relative ${
            isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]"
          } pb-[130px]`}>
          <div className="max-w-1160px min-h-screen flex-1 mx-auto">
            <NavigationBar
              title="Year"
              customStyle={isMobileVersion ? null : { marginTop: 0 }}
              isMobileVersion={isMobileVersion}
              onBackPressed={() =>
                router.push(
                  `/explore/${process.env.NEXT_PUBLIC_CATEGORY_ACTIVE.split(
                    ","
                  )[0]
                    ?.toLowerCase()
                    ?.replace("venue cocktail", "bars")
                    ?.replace("venue beachful", "beach-clubs")
                    ?.replace("prefab company", "companies")
                    ?.replace("prefab home", "homes")}`
                )
              }
            />
            <div className="flex flex-col items-center px-[20px]">
              {listData
                ?.sort((a, b) => a.order - b.order)
                ?.map((item, index) => (
                  <Link href={`/guides/${item?.slug}`}>
                    <a className="bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1 p-4 rounded-full text-xl text-white hover:underline font-semibold uppercase text-center w-full max-w-[330px] mb-[20px]">
                      {item?.title}
                    </a>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GuideYear;
